import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import { RemoveFinalExamVariantAccess } from "../actions/teacherMutations";
import { formatServiceError } from "../Utilities/serviceErrorHelper";
import PromptGeneric from "../components/Modal/PromptGeneric";

export default function useRemoveFinalExamVariantAccess(onInvalidated) {
  const intl = useIntl();
  const [removeAccessPrompt, setRemoveAccessPrompt] = useState(null);
  const mutateRemoveAccess = useMutation({
    mutationFn: RemoveFinalExamVariantAccess,
  });

  const handleRemoveAccess = (accessId) => {
    mutateRemoveAccess.mutate(accessId, {
      onSuccess: (data) => {
        if (data?.status > 199 && data.status < 300) {
          toast.success(<FormattedMessage id="FinalExamAccessInvalidated" />);
          onInvalidated?.();
        } else {
          toast.warn(formatServiceError(intl, data));
        }
      },
    });
    setRemoveAccessPrompt(null);
  };

  const prompt = (
    <PromptGeneric
      isOpen={removeAccessPrompt != null}
      toggle={() => setRemoveAccessPrompt(null)}
      onProceed={() => handleRemoveAccess(removeAccessPrompt)}
      title={<FormattedMessage id="AreYouSure" />}
      text={<FormattedMessage id="SureYouWantInvalidateFinalExamAccess" />}
      btnText="Delete"
      danger={true}
    />
  );

  return { setRemoveAccessPrompt, prompt };
}
